import { DomainConfigType } from 'utils/Domain/Domain';

const legalGuaranteeLocaleMap: Record<string, string | undefined> = {
    'de-AT': 'de',
    'it-IT': 'it',
};

export const getLegalGuaranteeImageUrl = (domainConfig: DomainConfigType): string => {
    const locale =
        domainConfig.defaultLocale in legalGuaranteeLocaleMap
            ? legalGuaranteeLocaleMap[domainConfig.defaultLocale]
            : domainConfig.defaultLocale;

    return `/documents/legal-guarantee/legal-guarantee-${locale}.png`;
};
